import moment from 'moment';
import React, { Component } from "react";
import 'react-block-ui/style.css';
import Alert from 'react-s-alert';
import { Button, ControlLabel, FormControl, FormGroup, Glyphicon, InputGroup, Panel } from 'react-bootstrap';
import Datetime from 'react-datetime';
import ReportsService from '../utils/ReportsService';
import UsersService from '../utils/UsersService';

class ReportingDownloadTranscripts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      selected: {},
      search: '',
      startDate: moment().subtract(30, 'days'),
      endDate: moment(),
      submitting: false
    };
  }

  componentDidMount() {
    UsersService.allUsers()
      .then(data => {
        const coaches = (data || [])
          .filter(c => c.roles.includes("tcs_coach"))
          .sort((a, b) => (a.name > b.name ? 1 : -1));
        this.setState({ users: coaches });
      })
      .catch(error => {
        console.error('Error loading users:', error);
        this.setState({ users: [] });
      });
  }

  filteredUsers() {
    const term = this.state.search.trim().toLowerCase();
    if (!term) return this.state.users;
    return this.state.users.filter(u =>
      (u.name || '').toLowerCase().includes(term) ||
      (u.email || '').toLowerCase().includes(term)
    );
  }

  selectedEmails() {
    return Object.keys(this.state.selected).filter(email => this.state.selected[email]);
  }

  toggleConsultant = (email) => {
    const selected = { ...this.state.selected, [email]: !this.state.selected[email] };
    this.setState({ selected });
  };

  selectAll = () => {
    const selected = {};
    this.filteredUsers().forEach(u => { selected[u.email] = true; });
    this.setState({ selected: { ...this.state.selected, ...selected } });
  };

  clearAll = () => {
    this.setState({ selected: {} });
  };

  handleDownload = () => {
    this.setState({ submitting: true });

    const filter = {
      tcs_assigned_to: this.selectedEmails(),
      start_date: this.state.startDate,
      end_date: this.state.endDate
    };

    ReportsService.downloadTranscripts({ filter })
      .then(response => {
        this.setState({ submitting: false });
        Alert.success(
          (response && response.message) ||
          "Generating transcripts. You'll receive an email shortly."
        );
      })
      .catch(error => {
        console.error('Error requesting transcripts:', error);
        this.setState({ submitting: false });
        Alert.error("Could not start the export. Please try again.");
      });
  };

  render() {
    const { search, submitting, startDate, endDate } = this.state;
    const selectedCount = this.selectedEmails().length;
    const filtered = this.filteredUsers();

    return (
      <div style={{ marginTop: 20 }}>
        <Panel>
          <Panel.Heading>
            <Panel.Title componentClass="h3">Download Transcripts</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <div className="row">
              <div className="col-md-5">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                  <ControlLabel>
                    Sales Consultants{' '}
                    <span style={{ color: '#999', fontWeight: 'normal' }}>
                      {selectedCount > 0 ? `(${selectedCount} selected)` : '(all)'}
                    </span>
                  </ControlLabel>
                  <div style={{ fontSize: 12 }}>
                    <a role="button" onClick={this.selectAll} style={{ cursor: 'pointer' }}>Select all</a>
                    <span style={{ color: '#ccc' }}> | </span>
                    <a role="button" onClick={this.clearAll} style={{ cursor: 'pointer' }}>Clear</a>
                  </div>
                </div>

                <InputGroup style={{ marginBottom: 8 }}>
                  <InputGroup.Addon><Glyphicon glyph="search" /></InputGroup.Addon>
                  <FormControl
                    type="text"
                    placeholder="Search consultants"
                    value={search}
                    onChange={e => this.setState({ search: e.target.value })}
                  />
                </InputGroup>

                <div style={{
                  border: '1px solid #ddd',
                  borderRadius: 4,
                  maxHeight: 300,
                  overflowY: 'auto',
                  background: '#fff'
                }}>
                  {filtered.length === 0 && (
                    <div style={{ padding: 12, color: '#999' }}>No consultants found.</div>
                  )}
                  {filtered.map(user => {
                    const checked = !!this.state.selected[user.email];
                    return (
                      <label
                        key={user.email}
                        style={{
                          display: 'block',
                          padding: '8px 12px',
                          margin: 0,
                          borderBottom: '1px solid #f2f2f2',
                          fontWeight: 'normal',
                          cursor: 'pointer',
                          background: checked ? '#f5faff' : 'transparent'
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() => this.toggleConsultant(user.email)}
                          style={{ marginRight: 10 }}
                        />
                        {user.name}
                      </label>
                    );
                  })}
                </div>
                <p className="text-muted" style={{ fontSize: 12, marginTop: 6 }}>
                  Leave all unchecked to include every consultant.
                </p>
              </div>

              <div className="col-md-3">
                <FormGroup>
                  <ControlLabel>Start Date</ControlLabel>
                  <Datetime
                    timeFormat={false}
                    value={startDate}
                    onChange={value => this.setState({ startDate: value })}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>End Date</ControlLabel>
                  <Datetime
                    timeFormat={false}
                    value={endDate}
                    onChange={value => this.setState({ endDate: value })}
                  />
                </FormGroup>
              </div>

              <div className="col-md-4">
                <ControlLabel style={{ display: 'block' }}>&nbsp;</ControlLabel>
                <Button
                  bsStyle="primary"
                  bsSize="large"
                  onClick={this.handleDownload}
                  disabled={submitting}
                >
                  <Glyphicon glyph="envelope" style={{ marginRight: 8 }} />
                  {submitting ? 'Starting…' : 'Generate & Email'}
                </Button>
                <p className="text-muted" style={{ marginTop: 12 }}>
                  Transcripts are compiled in the background. We'll email you a
                  download link when the file is ready.
                </p>
              </div>
            </div>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}

export default ReportingDownloadTranscripts;
